import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { LocationModel } from 'common/models/page-models/Location/location-data-model';
import { LocationListingModel } from 'common/models/page-models/Location/location-grid-model';


// import { LocationModel, LocationListingModel } from 'common/models/page-models/location-model';
import { GridResolver } from 'common/resolvers/core-resolvers/grid.resolver';
import { SystemService } from 'common/services/core-services/system.service';

import { LocationGridWidgetService } from 'common/widget/location/location-grid-widget.service';
 
@Injectable({
    providedIn: 'root'
})
export class LocationGridResolver extends GridResolver<LocationModel, LocationListingModel> {
    constructor(
        protected fs: LocationGridWidgetService,
        protected override router: Router,
        protected override systemService: SystemService
    ) {
        super(fs, router, systemService);
    }
}